import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['button', 'panel'];

  connect() {
    const activeButton = this.buttonTargets.find((button) => button.classList.contains('is-active')) || this.buttonTargets[0];
    if (activeButton) this.showLanguage(activeButton.dataset.language);
  }

  show(event) {
    event.preventDefault();
    this.showLanguage(event.currentTarget.dataset.language);
  }

  showLanguage(language) {
    this.buttonTargets.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.language === language);
    });

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle('is-hidden', panel.dataset.language !== language);
    });
  }
}
